//
//
//
//
//
//
//
//

export default {
  props: ['name', 'placeholder', 'type', 'value'],
  data () {
    return {
      error: false
    }
  },
  directives: {
    type: {
      bind (el, { value }) {
        if (value === 'username') {
          el.type = 'text'
        } else if (value === 'password') {
          el.type = 'password'
        }
      }
    }
  },
  methods: {
    focus () {
      this.$refs['input'].focus()
    },
    input (el) {
      const isTrue = /^[0-9a-zA-Z._@]{6,16}$/.test(el.value)

      let value = el.value
      if (!isTrue) {
        value = ''
      }
      this.error = !isTrue
      this.$emit('input', value)
    }
  }
}
